import appInsights from "appInsights";

const trackEvent = (action: string, category: string, label: string, accountId?: number) => {
    appInsights.trackEvent({ name: label, properties: { action, category, accountId } });
}

export default trackEvent;